module.exports = {
  0: { api: 0, human: 'Basislastschrift (CORE)' },
  1: { api: 1, human: 'Firmenlastschrift (B2B)' }
}
